import React, { useContext, useEffect, useState } from 'react';
import { Heading } from '@/components/Elements/Heading';
import './qb.scss';
import { useQBAnalytics, useQBTransactions } from '../api/getTransacations';
import { QBTable } from '@/components/Elements/Table/QBTable';
import { UserContext } from '@/routes';
import { Dropdown } from 'react-bootstrap';
import DatePicker, { DayRange } from 'react-modern-calendar-datepicker';
import CalEventIcon from '@/assets/img/calender-evennt-icon.svg';
import { ReactComponent as CloseIcon } from '@/assets/img/Close-new.svg';
import { ReactComponent as DownArrow } from '@/assets/img/down-arrow.svg';
import { ReactComponent as TableFilter } from '@/assets/img/table-filter.svg';
import { ReactComponent as ShowColumnIcon } from '@/assets/img/show-columns.svg';
import { ReactComponent as QBAnalytics1 } from '@/assets/img/QBAnalytics1.svg';
import { ReactComponent as QBAnalytics2 } from '@/assets/img/QBAnalytics2.svg';
import { ReactComponent as QBAnalytics3 } from '@/assets/img/QBAnalytics3.svg';
import { ReactComponent as QBAnalytics4 } from '@/assets/img/QBAnalytics4.svg';
import { ReactComponent as DownloadCSV } from '@/assets/img/download-csv.svg';

import moment from 'moment';
import { default as ReactSelect, components } from 'react-select';
import QBCard from '../components/QBCard';
import ReactPaginate from 'react-paginate';
import { DashboardCard } from '@/features/events/components/AnalyticsData';
import { Loader } from '@/components/Loader/Loader';
import { useTranslation } from 'react-i18next';
import { businessCurrency } from '@/features/Language/api/getCountryCurrency';
import { useAuth } from '@/lib/auth';

export type Transaction = {
  label: string;
  value: string;
};
const Option = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option flex items-center justify-between">
          <label
            htmlFor={`option-check-${props.value}`}
            className="check-container"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
            <span className="checkmark"></span>
          </label>
          <div className="flex w-full items-center">
            <label className="name">{name}</label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Add Columns</span>}
      {valueLength > 0 &&
        !props.selectProps.inputValue &&
        `${valueLength} Column${valueLength != 1 ? 's' : ''} selected`}
      {React.Children.map(props.children, (child) => {
        return child && child.type === components.Input ? child : null;
      })}
    </components.ValueContainer>
  );
};
export type AnalyticsData = {
  income: string;
  expense: string;
  profit: string;
  cogs: string;
};
export const QBTransactions = () => {
  const { user } = useAuth();

  const currency = businessCurrency(user, 'USD');
  const userContext = useContext(UserContext);
  const getTransactionsMutation = useQBTransactions();
  const getAnalyticsMutation = useQBAnalytics();
  const [transactions, setTransactions] = useState<any>();
  const [showData, setShowData] = useState(false);
  const { t, i18n } = useTranslation();
  const [columns, setColumns] = useState<any>();
  const [actualTransactions, setActualTransactions] = useState<any>();
  const [selectedColumns, setSelectedColumns] = useState<any[]>([
    {
      name: 'Transaction Date',
      id: 'tx_date',
      isSelected: true,
    },
    {
      name: 'Transaction Type',
      id: 'txn_type',
      isSelected: true,
    },
    {
      name: 'Document No',
      id: 'doc_num',
      isSelected: true,
    },
    {
      name: 'Amount',
      id: 'subt_nat_amount',
      isSelected: true,
    },
  ]);
  const [selectedPage, setSelectedPage] = useState(1);

  const [tableCurrentIndex, setTableCurrentIndex] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedTransactionType, setSelectedTransactionType] = useState<string>('');
  const [showTransactions, setShowTransactions] = useState<boolean>(true);
  const [selectedDuration, setSelectedDuration] = useState<string>('');

  const sevenDaysBefore = moment().subtract(180, 'days');
  const endofDay = moment().endOf('day');
  const [analytics, setAnalytics] = useState<AnalyticsData>();
  const [dayRange, setDayRange] = useState<DayRange>({
    from: {
      year: sevenDaysBefore.year(),
      month: sevenDaysBefore.month() + 1,
      day: sevenDaysBefore.date(),
    },
    to: {
      year: endofDay.year(),
      month: endofDay.month() + 1,
      day: endofDay.date(),
    },
  });

  const perPage = 20;
  const columnList: any[] = [
    {
      name: 'Transaction Date',
      id: 'tx_date',
    },
    {
      name: 'Transaction Type',
      id: 'txn_type',
    },

    {
      name: 'Document No',
      id: 'doc_num',
    },
    {
      name: 'Memo',
      id: 'memo',
    },
    {
      name: 'Payment Method',
      id: 'pmt_mthd',
    },
    {
      name: 'Amount',
      id: 'subt_nat_amount',
    },
    {
      name: 'Term Name',
      id: 'term_name',
    },
    { name: 'Created By', id: 'create_by' },
    { name: 'Created Date', id: 'create_date' },
    { name: 'Custom Message', id: 'cust_msg' },
    { name: 'Due Date', id: 'due_date' },
    { name: 'Invoice Date', id: 'inv_date' },
    { name: 'Paid', id: 'is_ap_paid' },
    { name: 'Is Cleared', id: 'is_cleared' },
    { name: 'Is NO Post', id: 'is_no_post' },
    { name: 'Last Modified By', id: 'last_mod_by' },
    { name: 'Other Account', id: 'other_account' },
    { name: 'Printed', id: 'printed' },
    { name: 'Sales Customer 1', id: 'sales_cust1' },
    { name: 'Sales Customer 2', id: 'sales_cust2' },
    { name: 'Sales Customer 3', id: 'sales_cust3' },
    { name: 'Tracking Number', id: 'tracking_num' },
  ];
  const transactionTypes: Transaction[] = [
    {
      label: 'All Transactions',
      value: '',
    },
    {
      label: 'ReceivePayment',
      value: 'ReceivePayment',
    },
    {
      label: 'Transfer',
      value: 'Transfer',
    },
    {
      label: 'Deposit',
      value: 'Deposit',
    },
    {
      label: 'Credit',
      value: 'Credit',
    },
    {
      label: 'CashPurchase',
      value: 'CashPurchase',
    },
    {
      label: 'Invoice',
      value: 'Invoice',
    },

    {
      label: 'Bill',
      value: 'Bill',
    },

    {
      label: 'BillPaymentCheck',
      value: 'BillPaymentCheck',
    },

    {
      label: 'Charge',
      value: 'Charge',
    },
    {
      label: 'BillableCharge',
      value: 'BillableCharge',
    },
    {
      label: 'JournalEntry',
      value: 'JournalEntry',
    },
    {
      label: 'CreditCardCredit',
      value: 'CreditCardCredit',
    },
    {
      label: 'VendorCredit',
      value: 'VendorCredit',
    },
    {
      label: 'BillPaymentCreditCard',
      value: 'BillPaymentCreditCard',
    },
    {
      label: 'CreditRefund',
      value: 'CreditRefund',
    },
  ];
  const dateDuration: any[] = [
    {
      label: 'Select Duration',
      value: '',
    },
    {
      label: 'Today',
      value: 'Today',
    },
    {
      label: 'Yesterday',
      value: 'Yesterday',
    },
    {
      label: 'This Month',
      value: 'This Month',
    },
    {
      label: 'Last Month',
      value: 'Last Month',
    },
    {
      label: 'This Fiscal Year',
      value: 'This Fiscal Year',
    },
  ];

  useEffect(() => {
    updateSearchQuery();
  }, [selectedTransactionType, selectedDuration, selectedColumns, dayRange]);

  useEffect(() => {
    setTransactionData(0, true);
  }, [actualTransactions]);
  const fetchTransactions = async (searchQuery: string, analyticsQuery: string, csv = false) => {
    //console.log('search query ', searchQuery);
    const analyticsRes = await getAnalyticsMutation.mutateAsync({ searchQuery: analyticsQuery });
    updateAnalyticsData(analyticsRes.Rows.Row);

    const res = await getTransactionsMutation.mutateAsync({ searchQuery });
    if (csv) {
      const dataUri = window.URL.createObjectURL(new Blob([res], { type: 'text/csv' }));
      window.open(dataUri);
    } else {
      setActualTransactions(res?.Rows?.Row ? res?.Rows?.Row : []);
      setColumns(res?.Columns?.Column);
      setTotalRecords(res?.Rows?.Row ? res.Rows.Row.length : 0);
    }
  };

  const updateAnalyticsData = (row: any) => {
    const income: any = row.find((r: any) => r.group === 'Income');
    const expense: any = row.find((r: any) => r.group === 'Expenses');
    const profit: any = row.find((r: any) => r.group === 'GrossProfit');
    const cogs: any = row.find((r: any) => r.group === 'COGS');

    setAnalytics({
      income:
        `${currency} $` + income?.Summary?.ColData[1] && income?.Summary?.ColData[1]?.value
          ? income?.Summary?.ColData[1].value
          : 0,
      expense:
        `${currency} $` + expense?.Summary?.ColData[1] && expense?.Summary?.ColData[1]?.value
          ? expense?.Summary?.ColData[1]?.value
          : 0,
      profit:
        `${currency} $` + profit?.Summary?.ColData[1] && profit?.Summary?.ColData[1]?.value
          ? profit?.Summary?.ColData[1].value
          : 0,
      cogs:
        `${currency} $` + cogs?.Summary?.ColData[1] && cogs?.Summary?.ColData[1]?.value
          ? cogs?.Summary?.ColData[1].value
          : 0,
    });
  };

  const setTransactionData = (pageIndex: number, reset = false) => {
    if (reset) {
      if (actualTransactions) {
        setTransactions(
          actualTransactions.slice(pageIndex * perPage, pageIndex * perPage + perPage)
        );
      }
      setTableCurrentIndex(0);
    } else {
      if (transactions) {
        setTransactions(
          transactions.concat(
            actualTransactions.slice(pageIndex * perPage, pageIndex * perPage + perPage)
          )
        );
      }
      setTableCurrentIndex(pageIndex);
    }
    userContext && !userContext?.isLandscape && window.scrollTo(0, 0);
  };
  const onTableStateChange = (pageIndex: number) => {
    setTransactionData(pageIndex);
  };

  const onTransactionTypeClicked = (transaction: Transaction) => {
    setSelectedTransactionType(transaction.value);
  };
  const onDateDurationClicked = (duration: any) => {
    setSelectedDuration(duration.value);
    clearDayRange();
  };
  const onDateRangeChange = (data: any) => {
    setDayRange(data);
    setSelectedDuration('');
  };

  const updateSearchQuery = (csv = false) => {
    let searchQuery = '';
    let analyticsQuery = '';
    if (csv) {
      searchQuery = `?csv=${csv}`;
    }
    //date_macro=Last Fiscal Quarter&transaction_type=CreditCardCharge&columns=account_name,
    if (selectedTransactionType && selectedTransactionType != 'All Transactions') {
      if (searchQuery) {
        searchQuery = searchQuery + `&transaction_type=${selectedTransactionType}`;
      } else {
        searchQuery = `?transaction_type=${selectedTransactionType}`;
      }
    }
    let finalColumns;
    if (!selectedColumns) {
      finalColumns = [
        {
          name: 'Name',
          id: 'name',
          isSelected: true,
        },
      ];
    } else {
      finalColumns = [...selectedColumns];
    }
    if (finalColumns) {
      finalColumns.push({
        name: 'Name',
        id: 'name',
        isSelected: true,
      });
      const selectedValues = finalColumns.map((sc) => sc.id);
      if (searchQuery) {
        searchQuery = searchQuery + `&columns=${selectedValues.toString()}`;
      } else {
        searchQuery = `?columns=${selectedValues.toString()}`;
      }
      //console.log('searchQuery ', searchQuery);
    }
    if (selectedDuration || dayRange) {
      //console.log('dayrance ', dayRange);

      if (selectedDuration) {
        if (searchQuery) {
          searchQuery = searchQuery + `&date_macro=${selectedDuration}`;
        } else {
          searchQuery = `?date_macro=${selectedDuration}`;
        }
        if (analyticsQuery) {
          analyticsQuery = analyticsQuery + `&date_macro=${selectedDuration}`;
        } else {
          analyticsQuery = `?date_macro=${selectedDuration}`;
        }
      } else if (dayRange.from && dayRange.to) {
        const rangeValue = `start_date=${moment({
          year: dayRange?.from?.year,
          month: dayRange?.from?.month ? dayRange?.from?.month - 1 : 0,
          day: dayRange?.from?.day,
        }).format('YYYY-MM-DD')}&end_date=${moment({
          year: dayRange?.to?.year,
          month: dayRange?.to?.month ? dayRange?.to?.month - 1 : 0,
          day: dayRange?.to?.day,
        }).format('YYYY-MM-DD')}`;
        if (searchQuery) {
          searchQuery = searchQuery + '&' + rangeValue;
        } else {
          searchQuery = '?' + rangeValue;
        }
        if (analyticsQuery) {
          analyticsQuery = analyticsQuery + '&' + rangeValue;
        } else {
          analyticsQuery = '?' + rangeValue;
        }
      }
    }

    fetchTransactions(searchQuery, analyticsQuery, csv);
  };

  const formatDateRange = () => {
    return dayRange?.from && dayRange?.to
      ? moment({
          year: dayRange?.from?.year,
          month: dayRange?.from?.month ? dayRange?.from?.month - 1 : 0,
          day: dayRange?.from?.day,
        }).format('DD MMM YYYY') +
          ' - ' +
          moment({
            year: dayRange?.to?.year,
            month: dayRange?.to?.month ? dayRange?.to?.month - 1 : 0,
            day: dayRange?.to?.day,
          }).format('DD MMM YYYY')
      : 'Select Date Range';
  };

  const clearDayRange = () => {
    setDayRange({ from: null, to: null });
  };

  const startIndex = selectedPage == 1 ? 1 : (selectedPage - 1) * perPage + 1;
  const endIndex =
    selectedPage == 1
      ? 1 * perPage
      : selectedPage == totalRecords
      ? totalRecords
      : selectedPage * perPage;

  const paginationText = `Showing ${startIndex} to ${endIndex} of ${totalRecords} entries`;
  const handlePageClick = async (event: any) => {
    setSelectedPage(event.selected + 1);
    setTransactionData(event.selected + 1, true);
  };
  const onShowClick = () => {
    setShowData(!showData);
  };

  const downloadQbTransactions = () => {
    updateSearchQuery(true);
  };

  return (
    <section className="qb-section container-bg">
      <Heading
        title="QuickBooks"
        description="Monitor all your QuickBooks transactions with your customers"
      />
      <div className="qb-analytics">
        {!userContext?.isLandscape && (
          <div className="top-nav-analytics">
            <Heading title="Business Numbers" description="" size="sm" />
            <DownArrow
              className={`down-icon  ${showData ? 'show' : 'hide'}`}
              onClick={onShowClick}
            />
          </div>
        )}

        {(showData || userContext?.isLandscape) && (
          <>
            <DashboardCard
              label="Gross Profit"
              value={analytics?.profit}
              statsPercentage={0}
              statsDescription=""
              cardClassName="card-4"
              icon={<QBAnalytics1 />}
              unit=""
            />
            <DashboardCard
              label="Income"
              value={analytics?.income}
              statsPercentage={0}
              statsDescription=""
              cardClassName="card-4"
              icon={<QBAnalytics2 />}
              unit=""
            />
            <DashboardCard
              label="Expense"
              value={analytics?.expense}
              statsPercentage={0}
              statsDescription=""
              cardClassName="card-4"
              icon={<QBAnalytics3 />}
              unit=""
            />
            <DashboardCard
              label="Cost of Good Sold"
              value={analytics?.cogs}
              statsPercentage={0}
              statsDescription=""
              cardClassName="card-4"
              icon={<QBAnalytics4 />}
              unit=""
            />
          </>
        )}
      </div>
      {
        <div className="content">
          <div className="card-top-header">
            {userContext?.isLandscape ? (
              <Heading size="sm" title="Transaction List" />
            ) : (
              <div className="top-nav-analytics">
                <Heading size="sm" title="Transaction List" />
                <DownArrow
                  className={`down-icon  ${showData ? 'show' : 'hide'}`}
                  onClick={() => setShowTransactions(!showTransactions)}
                />
              </div>
            )}
            {((showTransactions && !userContext?.isLandscape) || userContext?.isLandscape) && (
              <div className="right-action petsked-form">
                <span className="group">
                  <button
                    type="button"
                    className="download-csv"
                    disabled={getTransactionsMutation.isLoading}
                    onClick={() => {
                      downloadQbTransactions();
                    }}
                  >
                    <DownloadCSV />
                  </button>
                  <Dropdown className={`transaction-dropdown tran-type`}>
                    <Dropdown.Toggle
                      variant="success"
                      className="drop-down-btn dropdown-toggle btn btn-success"
                      id="dropdown-basic"
                    >
                      <span className="button-label">
                        {selectedTransactionType ? selectedTransactionType : 'All Transactions'}
                      </span>
                      <DownArrow className="down-arrow" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {transactionTypes &&
                        transactionTypes?.map((transaction: Transaction, index: number) => {
                          return (
                            <Dropdown.Item
                              key={`dropdown-item-${index}`}
                              onClick={() => {
                                onTransactionTypeClicked(transaction);
                              }}
                            >
                              {transaction.label}
                            </Dropdown.Item>
                          );
                        })}
                    </Dropdown.Menu>
                  </Dropdown>
                  <Dropdown className={`transaction-dropdown date-filter`} autoClose="outside">
                    <Dropdown.Toggle
                      variant="success"
                      className="drop-down-btn dropdown-toggle btn btn-success"
                      id="dropdown-basic"
                    >
                      <span className="button-label">
                        <TableFilter />
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item key={`dropdown-item-pre-date`}>
                        <div>
                          <p className="filter-label">Duration</p>
                          <Dropdown className={`transaction-dropdown duration-filter`}>
                            <Dropdown.Toggle
                              variant="success"
                              className="drop-down-btn dropdown-toggle btn btn-success"
                              id="dropdown-basic"
                            >
                              <span className="button-label">
                                {selectedDuration ? selectedDuration : 'Select Duration'}{' '}
                              </span>
                              <DownArrow className="down-arrow" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {dateDuration &&
                                dateDuration?.map((duration: any, index: number) => {
                                  return (
                                    <Dropdown.Item
                                      key={`dropdown-item-${index}`}
                                      onClick={() => {
                                        onDateDurationClicked(duration);
                                      }}
                                    >
                                      {duration.label}
                                    </Dropdown.Item>
                                  );
                                })}{' '}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item key={`dropdown-item-cust-date`}>
                        <div>
                          <p className="filter-label">Custom Range</p>
                          <div className="input-date">
                            <div className="date-filter-events">
                              <img src={CalEventIcon} className="cal-event-icon" />
                              <DatePicker
                                calendarClassName="petsked-rangepicker"
                                value={dayRange}
                                onChange={onDateRangeChange}
                                formatInputText={formatDateRange}
                                colorPrimary="#F85663"
                                colorPrimaryLight="#FBF1F1"
                                calendarPopperPosition="auto"
                              />
                              {dayRange.from && dayRange.to && (
                                <CloseIcon
                                  className="close-icon-calendar"
                                  onClick={clearDayRange}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </span>
                <span className="span-multiselect-react">
                  <ReactSelect
                    className="multiselect-react"
                    options={columnList}
                    isMulti={true}
                    isSearchable={true}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      setSelectedColumns(selected);
                    }}
                    classNamePrefix={'petsked-multiselect'}
                    getOptionLabel={(option: any) => option.name}
                    getOptionValue={(option: any) => option.id}
                    components={{
                      Option,
                      ValueContainer,
                    }}
                    placeholder={'Select Columns'}
                    value={selectedColumns}
                  />
                  <ShowColumnIcon className="column-icon" />
                </span>
              </div>
            )}
          </div>
          {((showTransactions && !userContext?.isLandscape) || userContext?.isLandscape) && (
            <div className="qb-list petsked-table">
              {userContext?.isLandscape ? (
                <>
                  {transactions && (
                    <QBTable
                      columns={columns}
                      data={transactions}
                      tableInitialState={{
                        tableTotalRecords: totalRecords,
                        tablePageIndex: tableCurrentIndex,
                      }}
                      onTableStateChange={onTableStateChange}
                    />
                  )}
                </>
              ) : (
                <>
                  <div className="qbcards">
                    {transactions &&
                      transactions.map((tr: any, index: number) => (
                        <QBCard
                          key={`qbcard-${index}`}
                          data={tr}
                          columns={columns}
                          dataIndex={index}
                        />
                      ))}
                  </div>
                  {totalRecords > 10 && (
                    <div className="paginate">
                      <p className="description">{paginationText}</p>
                      <div className="pagination-stores">
                        <ReactPaginate
                          nextLabel=""
                          onPageChange={handlePageClick}
                          pageRangeDisplayed={3}
                          marginPagesDisplayed={2}
                          pageCount={totalRecords / 10}
                          previousLabel=""
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item previous-button"
                          previousLinkClassName="page-link"
                          nextClassName="page-item next-button"
                          nextLinkClassName="page-link"
                          breakLabel="..."
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          containerClassName="pagination"
                          activeClassName="active"
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
              {userContext?.isLandscape && getTransactionsMutation.isLoading && <Loader text="" />}
            </div>
          )}
        </div>
      }
    </section>
  );
};
